export const calculateGameScore = (timeInSeconds: number, turns: number): number => {
  // Constants

 
   return Number(timeInSeconds) + Number(turns)
} 



